import React, { useEffect, useState, useRef } from 'react';
import Breadcrumb from '../../../components/common/breadcrumb';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Container, Row, Col, Card, Form, Button, Table } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useHistory } from "react-router-dom";
import SweetAlert from 'sweetalert2';
import { URL_Start } from '../../../constant';
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import LoadingButton from '../commonComponent/LoadingButton';

let globallocationStateList = [];
const PRODetails = (id) => {
    const history = useHistory();
    const [modal, setModal] = useState();
    const toggleModal = () => { setModal(!modal) }
    const [errorModal, setErrorModal] = useState();
    const errorHandler = () => { setModal(true); setErrorModal(true); }
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [LocationStateList, SetLocationStateList] = useState([]);
    const [LocationRegionList, SetLocationRegionList] = useState([]);
    const [LGlbLocationRegionList, SetLGlbLocationRegionList] = useState([]);
    const [LocationDistrictList, SetLocationDistrictList] = useState([]);
    const [LGLocationDistrictList, SetLGLocationDistrictList] = useState([]);
    const isFirstRender = useRef(false);
    const isCheckedRender = useRef(false);
    const isStateCheckedRender = useRef(false);

    const resetLocationSelections = () => {
        globallocationStateList = [];
        SetLGlbLocationRegionList([]);
        SetLGLocationDistrictList([]);
        SetLocationRegionList([]);
        SetLocationDistrictList([]);
        isFirstRender.current = false;
        isCheckedRender.current = false;
        isStateCheckedRender.current = false;
    }

    useEffect(() => { GetStates("1"); GetDetails(); }, []);

    const GetStates = async (id) => {
        try {
            let url = URL_Start + 'master/getstateslist/' + id
            await axios.get(url).then((response) => {
                const data = response.data;
                if (data.Success) { SetLocationStateList(data.Data || []); }
            }).catch(function (error) { });
        }
        catch (error) { SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); }
    }

    const asyncFunRegionLocationBindDetails = async (isChecked, selectedStates = null, isHydrating = false) => {
        try {
            let url = URL_Start + 'master/getBindLocationRegionDetails'
            const statePayload = selectedStates || globallocationStateList;
            let options = {
                method: 'POST',
                url: url,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8'
                },
                data: { objTblLocationTypeList: statePayload }
            };
            let response = await axios(options);
            let responseOK = response && response.status == 200;
            if (responseOK) {
                const data = response.data;
                if (data.Success) {
                    const ds = data.Data;
                    SetLocationRegionList([]);
                    if (ds != null && ds.length > 0) { SetLocationRegionList(ds); }
                    else { SetLocationRegionList([]); }

                    if (ds != null && ds.length > 0) {
                        if (isChecked == false && isHydrating === false) {
                            SetLGlbLocationRegionList((prev) => [...prev.filter(o1 => ds.some(o2 => o1.RegionId == o2.RegionId))]);
                        }
                    }
                    else { SetLGlbLocationRegionList([]); }
                }
                else { SetLocationRegionList([]); SetLGlbLocationRegionList([]); }
            }
        }
        catch (error) { SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); }
    }

    const asyncFunDistinctLocationBindDetails = async (isChecked, selectedRegions = null, isHydrating = false) => {
        try {
            let url = URL_Start + 'master/getBindLocationDistrictDetails'
            const regionPayload = selectedRegions || LGlbLocationRegionList;
            let options = {
                method: 'POST',
                url: url,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8'
                },
                data: { objTblLocationTypeList: regionPayload }
            };
            let response = await axios(options);
            let responseOK = response && response.status == 200;
            if (responseOK) {
                const data = response.data;
                if (data.Success) {
                    const ds = data.Data;
                    SetLocationDistrictList([]);
                    if (ds != null && ds.length > 0) { SetLocationDistrictList(ds); }
                    else { SetLocationDistrictList([]); }

                    if (ds != null && ds.length > 0) {
                        if (isChecked == false && isHydrating === false) {
                            SetLGLocationDistrictList((prev) => [...prev.filter(o1 => ds.some(o2 => o1.DistrictId == o2.DistrictId))]);
                        }
                        else {
                            if (isHydrating === false) {
                                const allDistricts = ds.map((item) => ({ DistrictId: item.DistrictId }));
                                SetLGLocationDistrictList(allDistricts);
                            }
                        }
                    }
                    else { SetLGLocationDistrictList([]); }
                    isFirstRender.current = false;
                }
                else { SetLocationDistrictList([]); SetLGLocationDistrictList([]); }
            }
        }
        catch (error) { SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); }
    }
    const GetDetails = async () => {
        try {
            if (localStorage.getItem('fbId') !== null) {
                setIsLoading(true);
                // Clear previous edit context before hydrating new record.
                resetLocationSelections();
                formik.values.id = localStorage.getItem('fbId');
                let url = URL_Start + 'master/getProinfo/' + formik.values.id;
                await axios.get(url).then((response) => {
                    const data = response.data;
                    if (data.Success) {
                        const fldBoyInfo = data.Data;
                        formik.values.fieldBoyName = fldBoyInfo.PROName;
                        formik.values.age = fldBoyInfo.Age;
                        formik.values.mobileNo = fldBoyInfo.MobileNo;
                        formik.values.address = fldBoyInfo.Address;

                        globallocationStateList = [];
                        let selectedStates = [];
                        let selectedRegions = [];
                        const locationMappingList = fldBoyInfo.objPROLocationMappingList || fldBoyInfo.objLocationMappingList || fldBoyInfo.objDoctorLocationMappingList || [];
                        if (locationMappingList != null && locationMappingList.length > 0) {
                            const stateFlags = {}, stateOutput = [];
                            const regionFlags = {}, regionOutput = [];
                            const districtFlags = {}, districtOutput = [];
                            for (let i = 0; i < locationMappingList.length; i++) {
                                const row = locationMappingList[i];
                                if (row.StateId && !stateFlags[row.StateId]) { stateFlags[row.StateId] = true; stateOutput.push({ StateId: "" + row.StateId + "" }); }
                                if (row.RegionId && !regionFlags[row.RegionId]) { regionFlags[row.RegionId] = true; regionOutput.push({ RegionId: "" + row.RegionId + "" }); }
                                if (row.DistrictId && !districtFlags[row.DistrictId]) { districtFlags[row.DistrictId] = true; districtOutput.push({ DistrictId: "" + row.DistrictId + "" }); }
                            }
                            globallocationStateList = stateOutput;
                            selectedStates = stateOutput;
                            selectedRegions = regionOutput;
                            SetLGlbLocationRegionList(regionOutput);
                            SetLGLocationDistrictList(districtOutput);
                        }
                        else {
                            if (fldBoyInfo.SAPStateId !== null && fldBoyInfo.SAPStateId !== "") {
                                selectedStates = [{ StateId: "" + fldBoyInfo.SAPStateId + "" }];
                                globallocationStateList = selectedStates;
                            }
                            if (fldBoyInfo.SAPRegionId !== null && fldBoyInfo.SAPRegionId !== "") {
                                selectedRegions = [{ RegionId: "" + fldBoyInfo.SAPRegionId + "" }];
                                SetLGlbLocationRegionList(selectedRegions);
                            }
                            if (fldBoyInfo.SAPDistrictId !== null && fldBoyInfo.SAPDistrictId !== "") { SetLGLocationDistrictList([{ DistrictId: "" + fldBoyInfo.SAPDistrictId + "" }]); }
                        }

                        isStateCheckedRender.current = true;
                        isCheckedRender.current = true;
                        // Ensure edit screen always loads region/district lists from loaded mappings.
                        asyncFunRegionLocationBindDetails(false, selectedStates, true);
                        asyncFunDistinctLocationBindDetails(false, selectedRegions, true);
                        setIsLoading(false);
                    }
                }).catch(function (error) { setIsLoading(false); });
            }
            else {
                // Fresh add mode should never reuse previous location selections.
                resetLocationSelections();
            }
        }
        catch (error) { SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); setIsLoading(false); }
    }

    const StateCheckHandler = (e) => {
        const value = e.target.value;
        const isChecked = e.target.checked;
        const item = { StateId: value };

        if ((globallocationStateList.map(val => val["StateId"]).indexOf(item["StateId"]) == -1)) { globallocationStateList.push(item); }
        if (isChecked == false) { globallocationStateList = globallocationStateList.filter((d) => d.StateId != item.StateId); }
        isStateCheckedRender.current = true;
        asyncFunRegionLocationBindDetails(isChecked);
        isCheckedRender.current = isChecked;
    }

    const RegionCheckHandler = (e) => {
        const value = e.target.value;
        const isChecked = e.target.checked;
        const item = { RegionId: value };

        if ((LGlbLocationRegionList.map(val => val["RegionId"]).indexOf(item["RegionId"]) == -1)) {
            SetLGlbLocationRegionList((prev) => [...prev, item]);
        }
        if (isChecked == false) {
            SetLGlbLocationRegionList((prev) => [...prev.filter((d) => d.RegionId != item.RegionId)]);
        }
        isFirstRender.current = true;
        isCheckedRender.current = isChecked;
    }

    useEffect(() => {
        if (isFirstRender.current == true || isStateCheckedRender.current == true) {
            asyncFunDistinctLocationBindDetails(isCheckedRender.current);
        }
    }, [LGlbLocationRegionList]);

    const DistrictCheckHandler = (e) => {
        const value = e.target.value;
        const isChecked = e.target.checked;
        const item = { DistrictId: value };

        if ((LGLocationDistrictList.map(val => val["DistrictId"]).indexOf(item["DistrictId"]) == -1)) {
            SetLGLocationDistrictList((prev) => [...prev, item]);
        }
        if (isChecked == false) {
            SetLGLocationDistrictList((prev) => [...prev.filter((d) => d.DistrictId != item.DistrictId)]);
        }
    }

    const DistrictAllCheckHandler = (e) => {
        const isChecked = e.target.checked;
        if (isChecked == false) { SetLGLocationDistrictList([]); }
        else {
            const allDistricts = LocationDistrictList.map((item) => ({ DistrictId: item.DistrictId }));
            SetLGLocationDistrictList(allDistricts);
        }
    }

    const formik = useFormik({
        initialValues: { id: '0', fieldBoyName: '', age: '', mobileNo: '', address: '' },
        validationSchema: Yup.object({
            fieldBoyName: Yup.string().required('PRO name is required'),
            mobileNo: Yup.string().max(10, 'Mobile No must be  in 10 digits').min(10, 'Mobile No must be  in 10 digits').required('Mobile No is required'),
            age: Yup.number().typeError('Age must be a number').min(0, 'Min age must be 0.').max(99, 'Max age must be 99.'),
        }),
        onSubmit: values => {
            if (globallocationStateList.length == 0) { setModal(true); setErrorModal(true); return; }
            if (LocationRegionList.length > 0 && LGlbLocationRegionList.length == 0) { setModal(true); setErrorModal(true); return; }
            if (LGLocationDistrictList.length == 0) { setModal(true); setErrorModal(true); return; }
            setModal(false); setErrorModal(false); AddFieldBoys(values);
        }
    });
    const AddFieldBoys = async (values) => {
        setIsSaving(true);
        const primaryStateId = globallocationStateList.length > 0 ? globallocationStateList[0].StateId : "";
        const primaryRegionId = LGlbLocationRegionList.length > 0 ? LGlbLocationRegionList[0].RegionId : "";
        const primaryDistrictId = LGLocationDistrictList.length > 0 ? LGLocationDistrictList[0].DistrictId : "";
        const requestOptions = {
            Id: values.id,
            PROName: values.fieldBoyName,
            Age: values.age,
            MobileNo: values.mobileNo,
            Address: values.address,
            SAPStateId: primaryStateId,
            SAPRegionId: primaryRegionId,
            SAPDistrictId: primaryDistrictId,
            objTblLocationStateIds: globallocationStateList,
            objTblLocationRegionIds: LGlbLocationRegionList,
            objTblLocationDistrictIds: LGLocationDistrictList,
            AddedBy: localStorage.LoggedInUser
        };
        let url = URL_Start + 'master/SetPRO'
        await axios.post(url, requestOptions).then((response) => {
            const data = response.data;
            setIsSaving(false);
            if (data.Success) {
                SweetAlert.fire({ title: "Success", text: "Data saved successfully", icon: "success" });
                formik.resetForm();
                resetLocationSelections();
                localStorage.removeItem('fbId');
                history.push({ pathname: `${process.env.PUBLIC_URL}/master/pro-list`, search: `` });
            }
            else if (data.Data == "-2"){
                SweetAlert.fire({ title: "Error", text: "PRO already exists in same district", icon: "error" });
            }
            else if (data.Data == "-3"){
                SweetAlert.fire({ title: "Error", text: "No district selected", icon: "error" });
            }
            else { SweetAlert.fire({ title: "Application Exception", text: "Some error occured! Please try after sometime", icon: "error" }); setIsSaving(false); }
        }).catch(function (error) { setIsSaving(false); });
    }
    const cancelHandler = async (CentreId) => {
        resetLocationSelections();
        localStorage.removeItem('fbId');
        history.push({ pathname: `${process.env.PUBLIC_URL}/master/pro-list`, search: `` });
    }
    return (
        <React.Fragment>
            <Breadcrumb title="PRO Details" parent="Master" />
            <Container fluid>
                {
                    isLoading ?
                        <div className='text-center'> <Spinner animation="border" size='sm' /></div> :
                        <>
                            <Form onSubmit={formik.handleSubmit}>
                                <Row>
                                    <Col md={12}>
                                        <Card>
                                            <Card.Header className='pb-0'>
                                                <Card.Title>Details</Card.Title>
                                            </Card.Header>
                                            <Card.Body>
                                                <Form.Row>
                                                    <Col md={4}>
                                                        <Form.Group>
                                                            <Form.Label>Name<span className='text-required'>*</span></Form.Label>
                                                            <Form.Control type='text' name="fieldBoyName" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.fieldBoyName} />
                                                            {formik.touched.fieldBoyName && formik.errors.fieldBoyName ? (<div className='text-required'>{formik.errors.fieldBoyName}</div>) : null}
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Group>
                                                            <Form.Label>Mobile<span className='text-required'>*</span></Form.Label>
                                                            <Form.Control type="text" name="mobileNo" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.mobileNo} />
                                                            {formik.touched.mobileNo && formik.errors.mobileNo ? (<div className='text-required'>{formik.errors.mobileNo}</div>) : null}
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Group>
                                                            <Form.Label>Age</Form.Label>
                                                            <Form.Control type='text' name="age" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.age} />
                                                            {formik.touched.age && formik.errors.age ? (<div className='text-required'>{formik.errors.age}</div>) : null}
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group>
                                                            <Form.Label>Address</Form.Label>
                                                            <Form.Control as="textarea" name="address" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.address} />
                                                        </Form.Group>
                                                    </Col>
                                                </Form.Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row className="justify-content-center mt15">
                                    <Col md={12}>
                                        <Card>
                                            <Card.Header className='pb-0'>
                                                <Card.Title>Location Detail</Card.Title>
                                            </Card.Header>
                                            <Card.Body>
                                                <div className='text-required'>*State Selection required</div>
                                                <Form.Row className="justify-content-left mt15">
                                                    {LocationStateList.map((item) => {
                                                        const isStateChecked = globallocationStateList.some(function (d) { return d.StateId == item.Id });
                                                        return <Col md={4} lg={4} key={"state_" + `${item.Id}`}>
                                                            <Form.Label>
                                                                <input name={"chkState" + `${item.Id}`} className="checkbox_animated" type="checkbox"
                                                                    onChange={StateCheckHandler} value={`${item.Id}`} checked={isStateChecked} />
                                                                {item.Value}
                                                            </Form.Label>
                                                        </Col>
                                                    })}
                                                </Form.Row>

                                                {globallocationStateList.length > 0 && LocationRegionList.length > 0 && <><hr></hr>
                                                    <div className='text-required'>*Region Selection required</div>
                                                    <Form.Row className="justify-content-left mt15">
                                                        {LocationRegionList.map((item) => {
                                                            const isRegionChecked = LGlbLocationRegionList.some(function (d) { return d.RegionId == item.RegionId });
                                                            return <Col md={4} lg={4} key={"region_" + `${item.RegionId}`}>
                                                                <Form.Label>
                                                                    <input name={"chkRegion" + `${item.RegionId}`} className="checkbox_animated" type="checkbox"
                                                                        onChange={RegionCheckHandler} value={`${item.RegionId}`} checked={isRegionChecked} />
                                                                    {item.RegionName}
                                                                </Form.Label>
                                                            </Col>
                                                        })}
                                                    </Form.Row>
                                                </>}

                                                {LocationRegionList.length > 0 && LocationDistrictList.length > 0 && <><hr></hr>
                                                    <div className='text-required'>*District Selection required</div>
                                                    <div className='mt-1'>
                                                        <Form.Label className='mb-0'>
                                                            <input name={"chkDistrictAll"} className="checkbox_animated" type="checkbox"
                                                                onChange={DistrictAllCheckHandler}
                                                                checked={LocationDistrictList.length > 0 && LGLocationDistrictList.length == LocationDistrictList.length} />
                                                            Select All Districts
                                                        </Form.Label>
                                                    </div>
                                                    <Form.Row className="justify-content-left mt15">
                                                        {LocationDistrictList.map((item) => {
                                                            const isDistrictChecked = LGLocationDistrictList.some(function (d) { return d.DistrictId == item.DistrictId });
                                                            return <Col md={4} lg={4} key={"district_" + `${item.DistrictId}`}>
                                                                <Form.Label>
                                                                    <input
                                                                        name={"chkDistrict" + `${item.DistrictId}`}
                                                                        className="checkbox_animated"
                                                                        type="checkbox"
                                                                        onChange={DistrictCheckHandler}
                                                                        value={`${item.DistrictId}`}
                                                                        checked={isDistrictChecked}
                                                                    />
                                                                    {item.DistrictName}
                                                                </Form.Label>
                                                            </Col>
                                                        })}
                                                    </Form.Row>
                                                </>}
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row className='mt15'>
                                    <Col md={12} className='text-center'>
                                        <Button variant='secondary' className="mr-2" onClick={cancelHandler}>Cancel</Button>
                                        {isSaving ? <LoadingButton variantName='primary' cssName="" /> : <Button variant='primary' type='submit' onClick={errorHandler}>Save</Button>}
                                    </Col>
                                </Row>
                            </Form>
                        </>
                }
                {errorModal &&
                    <Modal isOpen={modal} toggle={toggleModal} centered={true}>
                        <ModalHeader toggle={toggleModal}>Errors</ModalHeader>
                        <ModalBody>
                            <p>{formik.touched.fieldBoyName && formik.errors.fieldBoyName ? (<div className='text-required'>{formik.errors.fieldBoyName}</div>) : null}</p>
                            <p>{globallocationStateList.length == 0 ? (<div className='text-required'>State Selection is Required</div>) : null}</p>
                            <p>{LocationRegionList.length > 0 && LGlbLocationRegionList.length == 0 ? (<div className='text-required'>Region Selection is Required</div>) : null}</p>
                            <p>{LGLocationDistrictList.length == 0 ? (<div className='text-required'>District Selection is Required</div>) : null}</p>
                            <p>{formik.touched.mobileNo && formik.errors.mobileNo ? (<div className='text-required'>{formik.errors.mobileNo}</div>) : null}</p>
                            <p>{formik.touched.age && formik.errors.age ? (<div className='text-required'>{formik.errors.age}</div>) : null}</p>
                        </ModalBody>
                        <ModalFooter>
                            <Button variant="secondary" onClick={toggleModal}>Cancel</Button>
                            <Button variant="primary" onClick={toggleModal}>Ok</Button>
                        </ModalFooter>
                    </Modal>
                }
            </Container>
        </React.Fragment >
    )
}

export default PRODetails;